import { render, staticRenderFns } from "./BookingSearch.vue?vue&type=template&id=5b64f43f&"
import script from "./BookingSearch.vue?vue&type=script&lang=js&"
export * from "./BookingSearch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports